var map = {
	"./arrow_back.svg": "c1dc",
	"./arrow_forward.svg": "9796",
	"./book-icon.svg": "bdf4",
	"./bulb-icon.svg": "87c2",
	"./close.svg": "0572",
	"./delete_forever.svg": "2f5f",
	"./edit.svg": "c560",
	"./expand_more.svg": "a91b",
	"./eye-off.svg": "bb6f",
	"./eye.svg": "0406",
	"./file.svg": "6b64",
	"./gift-icon.svg": "79ed",
	"./loading.svg": "ad40",
	"./medical-icon.svg": "126d",
	"./message-alert.svg": "914c",
	"./payment-change-white.svg": "d03c",
	"./payment-change.svg": "6e64",
	"./percent.svg": "eb00",
	"./playlist_add_blue.svg": "1de7",
	"./valid-email-error.svg": "be68",
	"./valid-email-valid.svg": "f890",
	"./valid-email-warning.svg": "05cb",
	"./warning.svg": "080e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b713";